import { useEffect, useState } from 'react';
import { Badge, Card } from '../Ui';
import { classifyOrder, getCriticality } from './control-tower-utils';
import type { OrderView } from './control-tower-utils';

interface ControlTowerMetricsProps {
  orders: OrderView[];
}

interface Metric {
  label: string;
  value: number;
  tone: 'slate' | 'amber' | 'blue' | 'green' | 'red' | 'purple';
}

export function ControlTowerMetrics({ orders }: ControlTowerMetricsProps) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), 30_000);
    return () => window.clearInterval(timer);
  }, []);

  const buckets = classifyOrder;
  const active = orders.filter((order) => buckets(order) !== 'excepcion');
  const produccion = orders.filter((order) => buckets(order) === 'produccion');
  const despacho = orders.filter((order) => buckets(order) === 'despacho');
  const critical = active.filter((order) => getCriticality(order, now).level === 'critical');
  const excepciones = orders.filter((order) => buckets(order) === 'excepcion');

  const metrics: Metric[] = [
    { label: 'Pedidos activos', value: active.length, tone: 'slate' },
    { label: 'Pedidos en producción', value: produccion.length, tone: 'blue' },
    { label: 'Pedidos listos', value: despacho.length, tone: 'green' },
    { label: 'Pedidos retrasados', value: critical.length, tone: critical.length > 0 ? 'red' : 'amber' },
    { label: 'Excepciones', value: excepciones.length, tone: excepciones.length > 0 ? 'purple' : 'slate' },
  ];

  return (
    <section className="grid gap-4 sm:grid-cols-2 lg:grid-cols-5" aria-label="Métricas de la torre de control">
      {metrics.map((metric) => (
        <Card key={metric.label} className="p-4">
          <div className="flex items-center justify-between gap-3">
            <span className="text-sm font-medium text-muted">{metric.label}</span>
            <Badge tone={metric.tone}>{metric.value}</Badge>
          </div>
        </Card>
      ))}
    </section>
  );
}
